import {  FromEventObservable  } from './FromEventObservable';

export const fromEvent = FromEventObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/fromEvent.ts